/* eslint-disable import/prefer-default-export */
import { Component, Inject, OnInit } from '@angular/core';
import { Observable, skip, startWith, switchMap } from 'rxjs';
import { ContentDetailsService } from 'src/app/service-pool/content-details/content-details.service';
import { ContentObjectDetails } from 'src/app/model/content-object-details.dto';
import { CookieService } from 'ngx-cookie';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { SubSink } from 'subsink';
import { OutletHomeService } from '../../service-pool/outlet-home-service/outlet-home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  home$: Observable<string>;

  carouselData: ContentObjectDetails = null;

  brand: string;

  sub = new SubSink();

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private contentDetailsService: ContentDetailsService,
    private cookieService: CookieService,
    private translationService: L10nTranslationService
  ) {}

  ngOnInit() {
    this.brand = this.cookieService.get('bid');
    this.sub.sink = this.contentDetailsService.getContentForLS().subscribe({
      next: () => {
        this.updateCarouselData();
      },
      error: (error) => {
        this.carouselData = {
            contentQuantity: '1',
            positionName: 'Home Carousel',
            items: this.defaultImage(),
          };
      }
    });
    this.translationService.onChange().pipe(
      skip(1),
      switchMap(() => {
        this.contentDetailsService.clearContentCache();
        return this.contentDetailsService.getContentForLS();
      })
    ).subscribe({
      next: () => {
        this.updateCarouselData();
      },
      error: () => {
          this.carouselData = {
            contentQuantity: '1',
            positionName: 'Home Carousel',
            items: this.defaultImage(),
          };
        },
    });
  }

  defaultImage() {
    if (this.locale.language === 'fr-CA') {
      return [
        {
          contentPath: `/assets/public/${this.brand}/images/Login_Background-fr.jpg`,
          displayName: '',
          redirectLink: null,
          objectOrder: 1,
        },
      ];
    }
    return [
      {
        contentPath: `/assets/public/${this.brand}/images/Login_Background.jpg`,
        displayName: '',
        redirectLink: null,
        objectOrder: 1,
      },
    ];
  }

  updateCarouselData() {
    this.carouselData = this.contentDetailsService.getProgramContentByPosition('Home Carousel');
    if (this.carouselData && (this.carouselData as any)?.error === true) {
      this.carouselData = {
        contentQuantity: '1',
        positionName: 'Home Carousel',
        items: this.defaultImage(),
      };
    } else if (!this.carouselData?.items) {
      this.carouselData = {
        contentQuantity: '1',
        positionName: 'Home Carousel',
        items: this.defaultImage(),
      };
    }
    if (this.carouselData?.items) {
      this.carouselData.items.sort((prev, curr) => prev.objectOrder - curr.objectOrder);
    }
  }
}
